import { debounce } from 'lodash-es';
import { type UIEvent, useCallback, useState } from 'react';

export interface ScrollSpy {
  isScrollable: boolean;
  scrollLimitY: number;
  scrollLimitX: number;
  scrollY: number;
  scrollX: number;
}

export interface UseScrollSpyResult {
  scrollSpy: ScrollSpy;
  onScroll: (event: UIEvent<HTMLElement>) => void;
}

export const useScrollSpy = (): UseScrollSpyResult => {
  const [scrollSpy, setScrollSpy] = useState<UseScrollSpyResult['scrollSpy']>({
    isScrollable: false,
    scrollLimitY: 99999,
    scrollLimitX: 99999,
    scrollY: 0,
    scrollX: 0,
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const onScroll: UseScrollSpyResult['onScroll'] = useCallback(
    debounce(
      (event) => {
        if (event.currentTarget) {
          setScrollSpy({
            isScrollable: event.currentTarget.scrollHeight > event.currentTarget.clientHeight,
            scrollLimitY:
              event.currentTarget.scrollHeight -
              event.currentTarget.clientHeight -
              /* buffer for padding & animation */ 5,
            scrollLimitX:
              event.currentTarget.scrollWidth -
              event.currentTarget.clientWidth -
              /* buffer for padding & animation */ 5,
            scrollX: event.currentTarget.scrollLeft,
            scrollY: event.currentTarget.scrollTop,
          });
        }
      },
      100,
      { leading: true, trailing: true },
    ),
    [scrollSpy],
  );

  return { scrollSpy, onScroll };
};
